// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import {useContext, useEffect, useState, useRef, useMemo} from "react";
import {AppContext} from "../contexts/AppContext";
import {SessionContext} from "../contexts/SessionContext";
import consumerSingleton from "./consumerSingleton";

export default () => {
    const {state} = useContext(AppContext);
    const {state: sessionState} = useContext(SessionContext);
    
    // Use useMemo to ensure stable consumer reference
    const consumer = useMemo(() => {
        const token = state.jwt;
        const orgId = sessionState.currentOrg?.id;
        
        if (!token) {
            console.log('useConsumer: No JWT token available');
            return null;
        }
        
        const c = consumerSingleton.getConsumer(token, orgId);
        
        // Ensure connection is open
        if (c && !c.connection.isActive()) {
            console.log('useConsumer: Opening connection');
            c.connection.open();
        }
        
        return c;
    }, [state.jwt, sessionState.currentOrg?.id]);
    
    return consumer;
}
